import _ from 'lodash';
import React, { Component } from 'react';

import Tooltip from './tooltip';
import ErrorTooltip from './error-tooltip';

const Required = ({ required }) => {
	if (required !== true) {

		return null;
	}

	return (
		<span className="fi-asterisk required"></span>
	);
};

export default class Label extends Component {
	render () {
		const { formStore, fieldKey, label: labelOverride } = this.props;

		const {
			label,
			required,
			tooltipContent,
			tooltipText,
			tooltipAt = 'top'
		} = formStore.get(fieldKey);

		const displayLabel = formStore.makeReplacement(
			_.isString(labelOverride) ? labelOverride : label
		);

		if (_.isEmpty(displayLabel)) {

			return null;
		}

		return (
			<label htmlFor={ fieldKey }>
				<ErrorTooltip
					fieldKey={ fieldKey }
					formStore={ formStore }
				/> { `${displayLabel} ` }

				<Tooltip
					tooltipContent={ tooltipContent }
					tooltipText={ tooltipText }
					fieldKey={ fieldKey }
				/>

				<Required
					required={ required }
				/>
			</label>
		);
	}
};
